import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { ViewManagerService } from '../../services/view-manager-service';

declare var $: any;
@Component({
  selector: '[main_header]',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.css'],
  host: {'[attr.id]': '\'testata\'', '[attr.role]': '\'banner\'', '[class.site-header]': '\'true\'' }
})
export class HeaderComponent implements OnInit  {
  urlWelcomeBoard: string = UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD;
  subscription: Subscription;
  show: boolean = true;

  constructor(private viewManagerService: ViewManagerService) {
  }

  ngOnInit() {
   this.subscription = this.viewManagerService.ctxHeader.subscribe(res => this.show = res);
  }
}
